export function isToko(value) {
  const v = parseInt(value, 10)
  return v === 0 ||!!String(value).match(/^1/)
}



// WEBPACK FOOTER //
// ./webapp/scripts/maori.js